import _ from "lodash";
import getApiUrl from "services/getApiUrl";

export const mountRecordsToFormula = async (currentForm, submitedData, fields) => {
    try {
        const formulaFields = fields.filter(field => field.fieldtype === 'formula' && !field.isReadOnly);
        if (!Array.isArray(formulaFields) || formulaFields.length === 0) return [];

        const idsFieldFormula = formulaFields.map(f => f._id);

        const checkIfIsEmpty = (data) => {
            return data && _.every(data, (item) => _.isEmpty(item.id) && (_.isNil(item.value) || (!_.isNumber(item.value) && _.isEmpty(item.value))));
        };

        let dataObj = _.assign({}, ...(Array.isArray(submitedData) ? submitedData : []));

        const emptyFields = Object.entries(dataObj)
            .filter(([key, value]) => checkIfIsEmpty(value))
            .map(([key]) => key);
        
        dataObj = _.omit(dataObj, ['acceptEmptyValues', ...emptyFields]);

        const payload = {
            formName: currentForm,
            idsFieldFormula,
            finalValuesField: [dataObj],
        };

        const { data } = await getApiUrl.post('/objetos/formularios/dados/formula', payload);
        if (!data?.success) {
            console.warn('Erro ao calcular fórmulas: ', data?.message);
            return [];
        }

        return data.message;

    } catch (err) {
        console.error('Erro em mountRecordsToFormula:', err);
        return [];
    }
}

export const mergeFormulaResults = (result, formulaResults) => {
    if (!Array.isArray(result) || !Array.isArray(formulaResults) || formulaResults.length === 0) {
        return result;
    }

    const formulaByField = new Map(
        formulaResults.map(f => [f.field, f])
    );
    return result.map(item => {
        const fieldName = Object.keys(item)[0];
        const formulaMatch = formulaByField.get(fieldName);
        if (!formulaMatch) return item;

        const entries = item[fieldName];
        if (!Array.isArray(entries) || entries.length === 0) return item;

        return {
            [fieldName]: [
                {
                    ...entries[0],
                    value: formulaMatch.value,
                },
                ...entries.slice(1)
            ],
        };
    });
};

export const clearFormulaFields = (result, fields) => {
    if (!Array.isArray(result) || !Array.isArray(fields)) return result;

    const formulaFieldName = new Set(
        fields
            .filter(f => f.fieldtype === 'formula' && !f.isReadOnly)
            .map(f => f.field)
    );

    if (formulaFieldName.size === 0) return result;

    return result.map(item => {
        if (!item || typeof item !== 'object') return item;

        const fieldName = Object.keys(item)[0];
        if (!formulaFieldName.has(fieldName)) return item;

        const entries = item[fieldName];
        if (!Array.isArray(entries) || entries.length === 0) return item;

        return {
            [fieldName]: [
                {
                    _id: '',
                    value: '',
                },
                ...entries.slice(1)
            ],
        };
    });
}

